import { Component, Input, EventEmitter, Output } from '@angular/core'
import { MatDialog, MatDialogModule, MatDialogTitle } from '@angular/material/dialog';
import { openConfirmDeleteGetResult } from '../dialog.confirmDelete.component'
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'wide-dialog-wrapper',
    template: `
<div class="big-dialog">
  <div mat-dialog-title class="title"
    [ngStyle]="{background: backgroundColor || 'none', flex: '0 1 ' + titleHeight + 'px', minHeight: titleHeight + 'px'}"
    [ngClass]="{smallTitle: smallTitle, bold: boldTitle, noBackground: !backgroundColor, whiteTitle: whiteTitle }">
    {{ dialogTitle }}
  </div>
  <div #content class="content main" mat-dialog-content [ngStyle]="{ margin: margin + 'px' }">
    <div #contentChildren class="content-children">
      <ng-content></ng-content>
    </div>
  </div>
  <div *ngIf="!hideBottom" mat-dialog-actions [ngStyle]="{flex: '0 1 '  + (titleHeight + 10) + 'px', minHeight: (titleHeight + 10) + 'px'}" >
    <button mat-button class="delete" *ngIf="delete" (click)="deleteCheck($event)"><icon icon="delete24"></icon></button>
    <button class="trashRightLabel" mat-button *ngIf="trashRightLabel" (click)="onTrashRight.emit()">{{ trashRightLabel }}</button>
    <button class="midLeftLabel" mat-button *ngIf="midLeftLabel" (click)="onMidLeft.emit()">{{ midLeftLabel }}</button>
    <div style="flex:1;"></div>
    <button class="midRightLabel" mat-button *ngIf="midRightLabel" (click)="onMidRight.emit()">{{ midRightLabel }}</button>
    <button matButton="filled" id="farRightButton" color="primary" [disabled]="disabled" (click)="onSubmit.emit()">{{ successLabel }}</button>
  </div>
</div>
`,
    styleUrls: ['./big-dialog-wrapper.scss'],
    standalone: true,
    imports: [CommonModule, IconComponent, MatButtonModule, MatDialogModule, MatDialogTitle]
})
export class BigDialogWrapperComponent {
  @Input() disabled = true
  @Input() hideBottom = false
  @Input() successLabel = 'DONE'
  @Input() dialogTitle = ''
  @Input() margin = 0
  @Input() titleHeight = 60
  @Input() backgroundColor
  @Input() whiteTitle = false
  
  @Input() deleteTitle = ''
  @Input() deleteText = ''

  @Input() smallTitle = false
  @Input() boldTitle = false
  @Input() delete = true
  @Input() midRightLabel: string
  @Input() midLeftLabel: string
  @Input() trashRightLabel: string

  @Output() onMidRight: EventEmitter<any> = new EventEmitter()
  @Output() onMidLeft: EventEmitter<any> = new EventEmitter()
  @Output() onTrashRight: EventEmitter<any> = new EventEmitter()

  @Output() onSubmit: EventEmitter<any> = new EventEmitter()
  @Output() onDelete: EventEmitter<any> = new EventEmitter()

  constructor(private dialog: MatDialog) { }

  async deleteCheck(event) {
    event.stopPropagation()
    const rect = event.target.getBoundingClientRect();
    const data = {
      title: this.deleteTitle,
      para: this.deleteText,
      deleteButtonText: 'DELETE',
      rect,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.onDelete.emit()
  }
}

